export default {
  get_notification_list: (state) => state.notifications.items,
  get_notification_list_pages: (state) => state.notifications.pages,
  get_unread_notification_count: (state) => state.notifications?.entity?.total_unread,
};
